export default __webpack_public_path__ + "static/media/caret.474a217e.svg";